'use strict'

import React from 'react'
import ReactDOM from 'react-dom'
import Main from './components/Main'

ReactDOM.render(<Main/>, document.getElementById('main'))



// WEBPACK FOOTER //
// ./src/main.js